import { GpsHelper } from '@/flightpath-components/services/GpsHelper';

export default class DurationFinder {
  // rough estimate to factor the estimated duration for a mission, will overestimate (can be large overestimation at slow speeds)
  static estimatedDurationFactor = 1.75;

  /*
      get the estimated mission duration for a simple path and speed
      returns a string with the format 'XX h XX min'
    */
  static findEstimatedMissionDurationHoursMinutes(path: google.maps.LatLng[], speed: number): string {
    if (path.length == 0 || speed == 0) return '0 h 0 min';

    const durationMinutes = this.findEstimatedMissionDurationMinutes(path, speed);
    const hours = Math.floor(durationMinutes / 60);
    const min = Math.ceil(durationMinutes % 60);
    return `${hours} h ${min} min`;
  }

  /*
      get the estimated mission duration for a simple path and speed in minutes
    */
  static findEstimatedMissionDurationMinutes(path: google.maps.LatLng[], speed: number): number {
    const pathLengthKm = GpsHelper.findPathLengthInMeters(path) / 1000;
    return (pathLengthKm / speed) * 60 * this.estimatedDurationFactor;
  }
}
